import { Stack } from '@/components/layout';
import { StackLayoutProps } from '@/components/layout/stack/types';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { memo, ReactNode } from 'react';
import { Platform, StyleSheet, TouchableOpacity } from 'react-native';

export const PlayerCardIndicator = memo(
  ({ color, ...props }: { color: string } & StackLayoutProps) => {
    const { scale } = useScaling();
    return <Stack width={scale(9)} height="100%" backgroundColor={color} {...props} />;
  },
);

export const PlayerCardRoot = memo(
  ({
    children,
    onPress,
    hideShadow = false,
    ...props
  }: {
    children: ReactNode;
    onPress: () => void;
    hideShadow?: boolean;
  } & StackLayoutProps) => {
    const styles = useStyles();
    const { scale } = useScaling();
    return (
      <TouchableOpacity activeOpacity={0.8} onPress={onPress}>
        <Stack
          direction="row"
          align="center"
          marginX={scale({ phone: 18, tablet: 0 })}
          height={scale(70)}
          backgroundColor="white"
          borderRadius={scale(4)}
          gap={scale(12)}
          overflow="hidden"
          style={hideShadow ? undefined : styles.playerCardShadow}
          {...props}>
          {children}
        </Stack>
      </TouchableOpacity>
    );
  },
);

export const useStyles = createStyles(({ scale }) => ({
  playerCardShadow:
    Platform.OS === 'ios'
      ? {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.16,
          shadowRadius: 2,
        }
      : {
          elevation: 2,
        },
  verticalSeparator: {
    width: StyleSheet.hairlineWidth,
    alignSelf: 'stretch' as const,
    backgroundColor: colors['5'],
  },
  avatarFrame: {
    backgroundColor: colors['0'],
  },
  profileLabel: {
    textTransform: 'uppercase',
    marginTop: scale(1),
  },
  playerName: {
    color: colors.Blue,
    paddingRight: scale(8),
  },
  playerAge: {
    color: colors['6'],
  },
}));
